import { render, staticRenderFns } from "./OurCertificates.vue?vue&type=template&id=a5117fba&scoped=true&"
import script from "./OurCertificates.vue?vue&type=script&lang=js&"
export * from "./OurCertificates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5117fba",
  null
  
)

export default component.exports